import { Slide } from './slide.model';

export class Landing {
  _id: string;
  name: string = '';
  slug: string = '';
  banner: string = '';
  description: string = '';
  slides: Array<Slide> = [];
  active: boolean = false;
  created: Date;
  updated: Date;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/landings/shared/landing.model.ts